<template>
  <div>
    <div class="rectangle" v-for="item in value.children" :key="item.id">
      <div class="hvh-flex align-baseline space-between my-3">
        <b>USC, Drugs, Procedures, Diagnoses, Cohorts</b>
        <div class="hvh-flex" v-if="item.children.length > 1">
          <ToggleButton class="font-sm" :value="criterionOperator(item)" :items="criterionOperatorOptions" @input="setOperator(item, $event)" />
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon class="criterion-icon" small v-on="on">mdi-help-circle-outline</v-icon>
            </template>
            <div>Control the logic for how multiple groups are combined to generate the cohort.</div>
            <div>Segment criteria groups can only be defined using AND operator.</div>
          </v-tooltip>
        </div>
      </div>
      <CohortSingleCriteria
        :value="child"
        :childInd="childInd"
        :showExcluded="childInd && item.children[1].criterionOperator !== 'Or'"
        :isAdvancedCriteria="isAdvancedCriteria"
        :cohorts="cohorts"
        @input="emitChange(item, childInd, $event)"
        @[removeProp(item)]="removeEvent(item, child)"
        v-for="(child, childInd) in item.children"
        :key="child.id"
      />
      <CohortCriteriaAddButton label="Add Event" @click="addEvent(item)" />
    </div>
    <CohortCriteriaAddButton label="Add Group of Events" @click="addGroupOfEvents" />
  </div>
</template>

<script>
import ToggleButton from '../../common/button/ToggleButton.vue';
import CohortCriteriaAddButton from './CohortCriteriaAddButton.vue';
import CohortSingleCriteria from './CohortSingleCriteria.vue';
export default {
  components: { CohortCriteriaAddButton, ToggleButton, CohortSingleCriteria },
  props: ['value', 'isAdvancedCriteria', 'cohorts'],
  data() {
    return {
      searchText: undefined,
      criterionOperatorOptions: [
        { text: 'And', value: 'And' },
        { text: 'Or', value: 'Or' },
        { text: 'Then', value: 'Then Anytime' },
      ],
    };
  },
  methods: {
    addGroupOfEvents() {
      this.$emit('input', {
        ...this.value,
        children: [...this.value.children, { id: Math.random(), children: [{}] }]
      });
    },
    addEvent(item) {
      var newItem = {
        ...item,
        children: [
          ...item.children,
          {
            id: Math.random(),
            excluded: false,
            criterionOperator: this.criterionOperator(item),
            thenAfterDays: 0,
          }],
      };
      var valueChildren = [...this.value.children]
        .replaceAt(this.value.children.indexOf(item), newItem);
      this.$emit('input', { ...this.value, children: valueChildren });
    },
    removeProp(item) {
      return item.children.length > 1 && 'remove' || null;
    },
    removeEvent(item, child) {
      var newItem = {
        ...item,
        children: [...item.children].removeAt(item.children.indexOf(child)),
      };
      var valueChildren = [...this.value.children]
        .replaceAt(this.value.children.indexOf(item), newItem);
      this.$emit('input', { ...this.value, children: valueChildren });
    },
    setOperator(item, operator) {
      var children = item.children
        .map((child, ind) => ({ ...child, criterionOperator: ind ? operator : child.criterionOperator }));
      var valueChildren = [...this.value.children]
        .replaceAt(this.value.children.indexOf(item), { ...item, children });
      this.$emit('input', { ...this.value, children: valueChildren });
    },
    emitChange(item, childInd, event) {
      var children = [...item.children]
        .replaceAt(childInd, event);
      var valueChildren = [...this.value.children]
        .replaceAt(this.value.children.indexOf(item), { ...item, children });
      this.$emit('input', { ...this.value, children: valueChildren });
    },
    criterionOperator(item) {
      if (item.children[1]) {
        var operator = item.children[1].criterionOperator.split(' ')[0];
        return this.criterionOperatorOptions.find(f => f.text === operator).value;
      }
      return this.criterionOperatorOptions[0].value;
    },
  },
};
</script>

<style lang="scss" scoped>
.rectangle {
  border-radius: 6px;
  background-color: #f6f6f7;
  box-shadow: inset 0 0 10px 0 rgba(0, 0, 0, 0.2);
  padding: 16px 10px;
  margin-bottom: 24px;
}

.criterion-icon {
  width: 32px;
}
</style>